var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FocusLayout',{attrs:{"title":_vm.$t('Nice to have you with us :)'),"subtitle":_vm.$t('Just register to join with us')}},[_c('RegisterForm',_vm._b({on:{"authenticated":function($event){return _vm.$router.push({ name: 'home' })}}},'RegisterForm',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }